import { motion } from 'framer-motion';
import { Wine, Home } from 'lucide-react';
import TastingLayout from '@/components/layout/TastingLayout';

export default function NotFoundPage() {
  return (
    <TastingLayout>
      <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
        >
          <Wine className="w-20 h-20 text-primary-500/50 mx-auto mb-6" />

          <h1 className="text-4xl font-display font-bold text-dark-50 mb-4">
            Seite nicht gefunden
          </h1>

          <p className="text-dark-400 max-w-md mx-auto mb-8">
            Die Seite, die du suchst, existiert nicht. Bitte überprüfe den Link oder
            scanne den QR-Code erneut.
          </p>

          <div className="space-y-4">
            <p className="text-dark-500 text-sm">
              Um an einem Tasting teilzunehmen, benötigst du einen gültigen Event-Code
              oder eine Einladung.
            </p>

            <div className="p-4 bg-dark-800/50 rounded-xl border border-dark-700">
              <p className="text-dark-300 text-sm">
                <strong>Beispiel-URLs:</strong>
              </p>
              <code className="text-primary-400 text-sm block mt-2">
                tasting.spiritvault.pro/ABC123
              </code>
              <code className="text-primary-400 text-sm block mt-1">
                tasting.spiritvault.pro/invite/token123
              </code>
            </div>
          </div>
        </motion.div>
      </div>
    </TastingLayout>
  );
}
